//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import OffersInMailbox from '~/components/section/offers-in-mailbox.vue'
import { capitalizeFirstLetter, dcopy } from '~/utils/utils'
import AdminSections from '~/components/admin-sections/admin-sections.vue'
import SeoSailingHolidays from '~/components/seo/sailing-holidays.vue'
import FaqItems from '~/components/Flotillas/FaqItems.vue'
import RequestAction from '~/components/global/RequestAction.vue'
import adminSectionPage from '~/mixins/admin-section-page'
import dayjs from '~/modules/dayjs'
import urlTranslator from '~/middleware/url-translator'
import OtherLocations from '~/components/seo/other-locations.vue'
import adminPage from '~/mixins/admin-page'
import PageTop from '~/components/section/page-top.vue'
import AdminSectionGallery from '~/components/admin-sections/section-gallery.vue'
import RequestBoatModal from '~/components/modal/boat/request-boat-modal.vue'
import RequestOfferForm from '~/components/form/user/request-offer-form.vue'
import SearchComponent from '~/components/search/page/search-component.vue'
import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'DigitalFlotilla',
  components: {
    SearchComponent,
    RequestOfferForm,
    RequestBoatModal,
    AdminSectionGallery,
    PageTop,
    OtherLocations,
    RequestAction,
    FaqItems,
    SeoSailingHolidays,
    AdminSections,
    OffersInMailbox
  },
  mixins: [adminSectionPage, adminPage, searchUtils],
  middleware: [urlTranslator],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      // const currency = ctx.store.getters['lang/currentCurrency']
      // const ietf = ctx.store.getters['lang/currentLanguage']?.ietf_locale || 'en-gb'
      const lang = ctx.store.getters['lang/locale']

      const page = await ctx.$axios.get('/api/content-page?link=digital-flotilla-new&lang=' + lang)

      if (Object.keys(page?.data || {}).length === 0) {
        ctx.redirect(302, ctx.app.router.resolve({ name: 'destinations' }).href)
        return
      }

      await ctx.store.dispatch('setBreadcrumbs', Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [
        {
          title: ctx.app.i18n.t('sailing-holidays'),
          url: ctx.app.router.resolve({ name: 'sailing-holidays' }).href
        },
        {
          title: page?.data?.data?.title,
          url: ctx.route.fullPath
        }
      ]))

      ctx.store.commit('SET_META_DATA', {
        title: page.data?.data.meta_title,
        meta: [
          { name: 'title', property: 'og:title', hid: 'title', content: page.data?.data.meta_title },
          { name: 'description', property: 'og:description', hid: 'description', content: page.data?.data.meta_description },
          { name: 'twitter:title', content: page.data?.data.meta_title },
          { name: 'author', content: 'Tubber' },
          { name: 'twitter:description', content: page.data?.data.meta_description }
        ],
        link: []
      })
      return { page: page.data }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      requestOffer: {
        date: {
          start: null,
          end: null
        },
        marina: null
      }
    }
  },
  head () {
    return {
      title: this.page?.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          property: 'og:description',
          content: this.page?.data.meta_description
        }
      ]
    }
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint',
      currentCurrency: state => state.lang.currentCurrency,
      loading: state => state.search.loading,
      location: state => state.search.locationFull
    }),
    ...mapGetters({
      currentCurrency: 'lang/currentCurrency',
      locale: 'lang/locale'
    }),
    getShowAllButton () {
      return {
        sliceCount: 3,
        text: this.$t('show-all') + ' ' + (this.amountResultsFound) + ' ' + this.$tc(`${this.$t('boat')} | ${this.$t('boats_low')}`, this.amountResultsFound),
        hrefLink: this.$Search.generateClientUrl()
      }
    },
    getTopGallery () {
      return { ...(this.page.galleries?.[0] || {}), type: 'gallery' }
    },
    amountResultsFound () {
      return this.$options.filters.numberWithCommas(this.$store.state.search.amountResultsFound)
    },
    getShowAllLink () {
      return this.$router.resolve({
        name: 'search',
        params: { location: 'croatia' },
        query: { extra: ['digital-flotilla'] }
      }).href
    },
    sortBy: {
      get () {
        return this.searchTerms.sortBy
      },
      set (value) {
        this.$store.dispatch('search/changeFilter', { key: 'sortBy', value })
        this.$store.dispatch('search/changeFilter', { key: 'page', value: null })
        if (this.$refs.filters) {
          this.$refs.filters.applyFilters()
        }
      }
    },
    boatTypes () {
      return this.$store.state.search.staticBoatTypes.map((t) => {
        return {
          ...t,
          name: t.translate ? capitalizeFirstLetter(this.$t(t.name.toLowerCase())) : t.name
        }
      })
    },
    getPage () {
      const modifiedPage = dcopy(this.page)

      const transformations = {
        sections: {
          2: {
            type: 'feature-items',
            addItems: 'featuredItems'
          },
          4: {
            type: 'gallery-with-text',
            addImages: 'galleries.1.images',
            addTexts: 'self'
          },
          6: {
            type: 'feature-items-with-number',
            addItems: 'featuredItemsWithNumber'
          },
          7: {
            type: 'blog-items',
            addItems: 'blogs'
          },
          8: {
            type: 'feature-items',
            addItems: 'featuredItemsWithIcon'
          }
        },
        collectTypes: {
          'feature-item': 'featuredItems',
          'feature-items-with-number': 'featuredItemsWithNumber',
          'feature-items-with-icon': 'featuredItemsWithIcon'
        }
      }

      const collections = {
        featuredItems: [],
        featuredItemsWithNumber: [],
        featuredItemsWithIcon: [],
        blogs: modifiedPage.blogs || []
      }

      const getValueByPath = (obj, path) => {
        if (path === 'self') {
          return obj
        }
        return path.split('.').reduce((acc, part) => acc?.[part], obj)
      }

      modifiedPage.sections = modifiedPage.sections?.map((section) => {
        const sectionCopy = { ...section }
        const sortOrder = sectionCopy.sort_order
        const sectionType = sectionCopy.type

        if (transformations.collectTypes[sectionType]) {
          let collectionName = transformations.collectTypes[sectionType]
          if (sectionCopy.raw_json?.['admin-section']?.type === 'with-numbers') {
            collectionName = 'featuredItemsWithNumber'
          } else if (sectionCopy.raw_json?.['admin-section']?.type === 'with-icons') {
            collectionName = 'featuredItemsWithIcon'
          }

          if (!collections[collectionName]) {
            collections[collectionName] = []
          }
          collections[collectionName].push(sectionCopy)
          return false
        }

        if (transformations.sections[sortOrder]) {
          const config = transformations.sections[sortOrder]

          if (config.type) {
            sectionCopy.type = config.type
          }

          if (config.addImages) {
            sectionCopy.images = getValueByPath(modifiedPage, config.addImages)
          }

          if (config.addTexts) {
            sectionCopy.texts = [{ ...sectionCopy }]
          }

          if (config.addItems) {
            sectionCopy.items = collections[config.addItems].sort((a, b) => a.sort_order - b.sort_order)
          }
        }

        return sectionCopy
      }).filter(Boolean)

      modifiedPage.sections = modifiedPage.sections.sort((a, b) => a.sort_order - b.sort_order)
      modifiedPage.galleries = []

      return modifiedPage
    }
  },
  mounted () {
    this.createdMethod()
    this.$scrollTo({ y: 0 })
  },
  methods: {
    createdMethod () {
      this.$Search.setAttributeValue('location', 'croatia')
      this.$Search.setAttributeValue('limit_date', false)
      this.$Search.setAttributeValue('extra', ['digital-flotilla'])

      this.$Search.setAttributeValue('sortBy', '-premium_boat')
      this.$Search.search({ changeUrl: false })
    },
    openRequestOfferForm ({ marina = null, date_start = null, date_end = null }) {
      this.requestOffer.marina = marina
      if (date_start) {
        this.requestOffer.date.start = dayjs(date_start).toDate()
      } else {
        this.requestOffer.date.start = dayjs().weekday(6).toDate()
      }
      if (date_end) {
        this.requestOffer.date.end = dayjs(date_end).toDate()
      } else {
        this.requestOffer.date.end = dayjs(this.requestOffer.date.start).add(7, 'd').toDate()
      }
      this.$modal.show('request-boat-modal')
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes()
    next()
  }
}
